export const DATA_GRID_STATE_KEY = 'nutrisense:billingDashboard:invoices:dataGrid:state'
